document.addEventListener('change', event => {
  if (event.target.matches('[data-sort-by]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  }
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('details.mobile-nav[open]').forEach(details => {
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });
});

document.addEventListener('click', event => {
  document.querySelectorAll('details.mobile-nav[open]').forEach(details => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

// Restore Shopify country/address defaults when customer forms are rendered.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('select[data-default]').forEach(select => {
    const desired = select.dataset.default;
    if (!desired) return;
    const option = [...select.options].find(item => item.value === desired || item.text === desired);
    if (option) select.value = option.value;
  });
});
